import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { Container, Typography } from "@/components";
import { FetchContext as context } from "@/contexts/FetchContext";
import { PointHistoryList, usePointHistory } from "@/features/common/PointHistory";

export const PointHistory = () => {
  const { state } = useContext(context);
  const { pointHistories, bottomRef } = usePointHistory();
  const { t } = useTranslation();

  return (
    <Container isLoading={state.loading}>
      <Helmet title={t("POINT_HISTORY")} />

      <Typography variant="h1" style={{ marginBottom: "24px" }}>
        {t("POINT_HISTORY")}
      </Typography>

      <PointHistoryList pointHistories={pointHistories} />

      <div ref={bottomRef} />
    </Container>
  );
};
